import { Box, Button, Divider, Typography, styled, useTheme } from "@mui/material"
import { type ReactNode, useState } from "react"
import { Minus, Plus } from "react-feather"
import { CollapsibleCtx } from "./collapsibleContext"

interface CollapsibleLabels {
  more: string
  less: string
}

export interface CollapsibleGroupProps {
  children: ReactNode
  labels?: CollapsibleLabels
  divider?: boolean
  defaultExpanded?: boolean
}

export const CollapsibleGroup = ({
  children,
  labels = { more: "Voir plus", less: "Voir moins" },
  divider = false,
  defaultExpanded = false,
}: CollapsibleGroupProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  return (
    <CollapsibleCtx.Provider value={{ expanded }}>
      <Box>
        {children}
        <Box mt={divider ? 4 : 1}>
          {divider && <Divider />}
          <Box display="flex" justifyContent="center" mt={2}>
            <ToggleButton
              expanded={expanded}
              labels={labels}
              onClick={() => setExpanded((current) => !current)}
            />
          </Box>
        </Box>
      </Box>
    </CollapsibleCtx.Provider>
  )
}

const ToggleButton = ({
  expanded,
  labels,
  onClick,
}: {
  expanded: boolean
  labels: CollapsibleLabels
  onClick: () => void
}) => {
  const { typography } = useTheme()
  const ToggleIcon = expanded ? Minus : Plus

  return (
    <StyledButton
      variant="outlined"
      onClick={onClick}
      aria-expanded={expanded}
      endIcon={<ToggleIcon size={typography.pxToRem(18)} />}
    >
      <Typography variant="14px" lineHeight={1}>
        {expanded ? labels.less : labels.more}
      </Typography>
    </StyledButton>
  )
}

const StyledButton = styled(Button)(({ theme: { palette } }) => ({
  borderColor: palette.grey.extraLight,
  color: palette.common.darkBlue,
}))
